import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getWithdraws = async ({ currencyId, pageNumber }) => {
  if (!currencyId) return Promise.resolve([]); // Prevent API call with undefined ID
  return axios.get(`/transaction/withdraw/${currencyId}/${pageNumber}`);
};

export const useWithdraws = ({ currencyId, pageNumber, config }) => {
  return useQuery({
    ...config,
    queryKey: ['withdraws', currencyId, pageNumber], // ✅ Ensure query invalidation on currency change
    queryFn: () => getWithdraws({ currencyId, pageNumber }),
    enabled: !!currencyId, // ✅ Prevents API calls when currencyId is undefined
  });
};
